<div class="overflow-hidden animate__animated animate__fadeIn ">
    <app-banner [data]="dataHeader" [type]="'slider'" id="scrollhome"></app-banner>
    <div class="flex flex-col px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-20 2xl:px-32">
        <app-features [data]="dataBrands" [type]="'brands'"></app-features>
        <br><br>
        <app-features [data]="dataProducts" [type]="'products'"></app-features>
    </div>
    <br> <br><br>
</div>